module.exports = __webpack_public_path__ + "img/payment_main.1c5bfc96.jpg";